import React, { useEffect, useState } from "react";
import i18n from "~/i18n";
import { useForm } from "react-hook-form";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";

// Components
import AuthenticationLayout from "~/layouts/AuthenticationLayout";
import { Case, If } from "~/common/components/If";

// Assets
import "~/assets/sass/pages/auth/join.scss";

// Pages
import JoinPolicy from "~/pages/auth/JoinPage/Contents/JoinPolicy";
import JoinForm from "~/pages/auth/JoinPage/Contents/JoinForm";
import JoinAuthMailSend from "~/pages/auth/JoinPage/Contents/JoinAuthMailSend";
import JoinPageHeader from "./components/header/JoinPageHeader";
import { useTranslation } from "react-i18next";

export const Terms = {
	SERVICE_POL: i18n.t("pages.auth.JoinPage.termsOfService"),
	PRIVACY_POL: i18n.t("pages.auth.JoinPage.privacyPolicy"),
	MARKETING: i18n.t("pages.auth.JoinPage.agree"),
};

const JoinPage = () => {
	const { t } = useTranslation();
	const registerForm = useForm();
	const currentPath = "join";
	const [currentStep, setCurrentStep] = useState("policy");
	const [checkPolicy, setCheckPolicy] = useState([]);
	const [validateModal, setValidateModal] = useState(false);

	const currentEmail = registerForm.watch("id_email");

	const [validateModalType, setValidateModalType] = useState("");
	const [validateModalMsg, setValidateModalMsg] = useState("");

	const registerRequest = useRequest("post", "vc/user/register");
	const registerRetryRequest = useRequest("post", `/vc/user/register/resend/${currentEmail}`);

	// 이메일 validation - 정규식
	const fnEmailDuplicateCheck = (idEmail) => {
		if (
			!idEmail.match(
				/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
			)
		) {
			registerForm.setError("id_email", {
				type: "pattern",
				message: t("pages.auth.JoinPage.Contents.JoinForm.includingAt"),
			});
		} else {
			registerForm.clearErrors("id_email");
		}
	};

	// 회원가입 Request
	const request = (data) => {
		fnEmailDuplicateCheck(currentEmail);
		const formData = {
			id: data.id_email,
			name: data.name,
			pw: data.pw,
			terms: checkPolicy,
		};
		registerRequest.call(formData);
	};

	const retryRequest = () => {
		registerRetryRequest.call(registerForm.watch());
	};

	// 회원가입 Response
	useEffect(() => {
		switch (registerRequest.state) {
			case API_STATE.done:
				setCurrentStep("mailSend");
				break;
			case API_STATE.error:
				switch (registerRequest.error.statusCode) {
					case 409:
						setValidateModalType("error");
						setValidateModal(true);
						setValidateModalMsg(t("pages.auth.JoinPage.Contents.JoinForm.duplication"));
						break;
					case API_STATE.error:
						switch (registerRequest.error.statusCode) {
							case 409:
								setValidateModalType("error");
								setValidateModal(true);
								setValidateModalMsg(
									t("pages.auth.JoinPage.Contents.JoinForm.duplication")
								);
								break;
							case 500:
								setValidateModalType("error");
								setValidateModal(true);
								setValidateModalMsg(
									t("pages.auth.JoinPage.Contents.JoinForm.retryMoment")
								);
								break;
							default:
								break;
						}
						break;
					default:
						break;
				}
				break;
			default:
				break;
		}
	}, [registerRequest.state, registerRequest.error, setCurrentStep]);

	return (
		<AuthenticationLayout contentSide={false} PATH={currentPath}>
			<section className={`section-` + currentStep}>
				<JoinPageHeader currentStep={currentStep} />
				<If condition={currentStep} {...{ setCurrentStep }}>
					<Case condition={"policy"}>
						<JoinPolicy setCheckPolicy={setCheckPolicy} />
					</Case>
					<Case condition={"joinForm"}>
						<JoinForm
							{...{
								registerForm,
								setCurrentStep,
								request,
								validateModal,
								setValidateModal,
								validateModalType,
								validateModalMsg,
							}}
						/>
					</Case>
					<Case condition={"mailSend"}>
						<JoinAuthMailSend {...{ registerForm, retryRequest }} />
					</Case>
				</If>
			</section>
		</AuthenticationLayout>
	);
};

export default JoinPage;
